<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage">
<p class="copyrightText">This edition of <em class="italic">Immelmann: The Eagle of Lille</em> is published in the United States of America in 2009 by<br/>
    CASEMATE<br/>
    908 Darby Road, Havertown, PA 19083</p>
<p class="copyrightText">and in the United Kingdom by<br/>
    CASEMATE<br/>
    17 Cheap Street, Newbury, RG14 5DD</p>
<p class="copyrightText"><img alt="" class="greenhill" src="Images/9781935149767_pic0002.png"/> <em class="italic">A Greenhill Book</em></p>
<p class="copyrightText">Copyright © 1990 &amp; 2009 Lionel Leventhal Ltd</p>
<p class="copyrightText">Appendix © Norman L. Franks 1990</p>
<p class="copyrightText">Typeset &amp; design © Casemate Publishers 2009</p>
<p class="copyrightText">ISBN 978-1-935149-76-7 / 978-1-932033-98-4</p>
<p class="copyrightText">Cataloging in publication data is available from the<br/>
    Library of Congress and the British Library.</p>
<p class="copyrightText">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without the prior permission of the publishers.</p>
<p class="copyrightText">Printed and bound in the United States of America</p>
<p class="copyrightText1">Publishing History:<br/>
<em class="italic">Immelmann, The Eagle of Lille</em> was first published in German as <em class="italic">der Adler von Lille</em> by K.F. Koehler Verlag, Leipzig in 1934. The first English edition was published by John Hamilton in 1935 or 1936. It was reissued in facsmile by Greenhill Books / Lionel Leventhal Ltd in 1990 with a new appendix by Norman Franks. This new edition has been completely retypeset but the original language has been left unaltered.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?4eb07e87